module.exports = __webpack_public_path__ + "static/img/tst2-04-1.0cd8b97.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-04-1.gif
// module id = IlN4
// module chunks = 1